import XtraVisualHelper from "@Scripts/Infrastructure/XtraVisualHelper";
import BasePage from "@Scripts/Pages/BasePage";

export default class HomePage extends BasePage {
    public static async init() {
        await super.init();

        this.setVisuals();
        this.setProductSlider();
    }

    private static setVisuals() {
        XtraVisualHelper.init();
        
        (<any>window).$(".visual-area").xtraVisual({
            timerInterval: 8000,
            isVisualLoaderEnabled: true,
            isSelectorEnabled: false,
            isTimerEnabled: true,
            isImageBackground: true,
            isSkinBackground: false,
            isSkinFullScreen: false,
            isGesture: true,
            isGestureNavigation: true,
            isKeyboardNavigation: true
        });
    }

    private static setProductSlider() {
        let visualSwiper = new (<any>window).Swiper(".swiper", {
            modules: [(<any>window).Autoplay,(<any>window).Navigation],
            loop: true,
            slidesPerView: 2,
            spaceBetween: 10,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                750: {
                    slidesPerView: 3,
                },
                1024: {
                    slidesPerView: 4,
                },
                1366: {
                    slidesPerView: 4,
                },
            },
        });
    }
}